import type { ModuleManifest } from "./types";

export const salesOrdersManifest: ModuleManifest = {
  name: "sales-orders",
  label: "Sales Order",
  labelPlural: "Sales Orders",

  coreBOSModule: "SalesOrder",
  wsidPrefix: "22x",

  type: "master-detail",
  detailModule: "InventoryDetails",
  masterField: "lineitem_id",

  routes: {
    list: "/sales-orders",
    show: "/sales-orders/show/:id",
    create: "/sales-orders/create",
    edit: "/sales-orders/edit/:id",
  },

  navigation: {
    icon: "ShoppingCartOutlined",
    order: 8,
    group: "Sales",
  },

  routing: {
    keywords: ["sales order", "sales orders", "order", "orders", "so", "sale"],
    searchFields: ["subject", "salesorder_no"],
    defaultSort: { field: "createdtime", order: "desc" },
  },

  context: {
    supported: true,
    entityKey: "sales-orders",
  },

  fields: [
    { name: "subject", label: "Subject", type: "string", required: true },
    {
      name: "salesorder_no",
      label: "SO Number",
      type: "string",
      readonly: true,
    },
    {
      name: "account_id",
      label: "Account",
      type: "reference",
      referenceModule: "Accounts",
      required: true,
    },
    {
      name: "contact_id",
      label: "Contact",
      type: "reference",
      referenceModule: "Contacts",
    },
    {
      name: "quote_id",
      label: "Quote",
      type: "reference",
      referenceModule: "Quotes",
    },
    {
      name: "potential_id",
      label: "Opportunity",
      type: "reference",
      referenceModule: "Potentials",
    },
    {
      name: "sostatus",
      label: "Status",
      type: "picklist",
      required: true,
      options: [
        { value: "Created", label: "Created" },
        { value: "Approved", label: "Approved" },
        { value: "Delivered", label: "Delivered" },
        { value: "Cancelled", label: "Cancelled" },
      ],
    },
    { name: "duedate", label: "Due Date", type: "date" },
    {
      name: "carrier",
      label: "Carrier",
      type: "picklist",
      options: [
        { value: "FedEx", label: "FedEx" },
        { value: "UPS", label: "UPS" },
        { value: "DHL", label: "DHL" },
        { value: "USPS", label: "USPS" },
        { value: "BlueDart", label: "BlueDart" },
      ],
    },
    { name: "exciseduty", label: "Excise Duty", type: "currency" },
    {
      name: "hdnSubTotal",
      label: "Sub Total",
      type: "currency",
      readonly: true,
    },
    {
      name: "hdnGrandTotal",
      label: "Grand Total",
      type: "currency",
      readonly: true,
    },
    {
      name: "hdnTaxType",
      label: "Tax Type",
      type: "picklist",
      options: [
        { value: "group", label: "Group" },
        { value: "individual", label: "Individual" },
      ],
    },
    { name: "txtAdjustment", label: "Adjustment", type: "currency" },
    { name: "hdnDiscountPercent", label: "Discount %", type: "number" },
    { name: "hdnDiscountAmount", label: "Discount Amount", type: "currency" },
    {
      name: "currency_id",
      label: "Currency",
      type: "reference",
      referenceModule: "Currency",
      defaultValue: "21x1",
    },
    {
      name: "conversion_rate",
      label: "Conversion Rate",
      type: "number",
      defaultValue: 1,
    },
    { name: "bill_street", label: "Billing Street", type: "string" },
    { name: "bill_city", label: "Billing City", type: "string" },
    { name: "bill_state", label: "Billing State", type: "string" },
    { name: "bill_code", label: "Billing Code", type: "string" },
    { name: "bill_country", label: "Billing Country", type: "string" },
    { name: "ship_street", label: "Shipping Street", type: "string" },
    { name: "ship_city", label: "Shipping City", type: "string" },
    { name: "ship_state", label: "Shipping State", type: "string" },
    { name: "ship_code", label: "Shipping Code", type: "string" },
    { name: "ship_country", label: "Shipping Country", type: "string" },
    { name: "terms_conditions", label: "Terms & Conditions", type: "text" },
    { name: "description", label: "Description", type: "text" },
    {
      name: "assigned_user_id",
      label: "Assigned To",
      type: "reference",
      referenceModule: "Users",
      hidden: true,
      defaultValue: "19x1",
    },
  ],

  relationships: [
    {
      module: "Accounts",
      field: "account_id",
      label: "Account",
      icon: "BankOutlined",
      displayField: "accountname",
    },
    {
      module: "Contacts",
      field: "contact_id",
      label: "Contact",
      icon: "UserOutlined",
      displayField: "lastname",
    },
    {
      module: "Potentials",
      field: "potential_id",
      label: "Opportunity",
      icon: "TrophyOutlined",
      displayField: "potentialname",
    },
    {
      module: "Quotes",
      field: "quote_id",
      label: "Quote",
      icon: "FileTextOutlined",
      displayField: "subject",
    },
    {
      module: "Invoice",
      relation: "one-to-many",
      label: "Invoices",
      icon: "FileTextOutlined",
      displayField: "invoice_no",
    },
  ],

  requiredFields: ["subject", "account_id", "sostatus", "assigned_user_id"],

  // Mass edit - fields are dynamically loaded from filterFields
  massEdit: {
    enabled: true,
  },
};
